import { render, staticRenderFns } from "./NewHighlightsSection.vue?vue&type=template&id=9fd8e94c&scoped=true"
import script from "./NewHighlightsSection.vue?vue&type=script&lang=ts"
export * from "./NewHighlightsSection.vue?vue&type=script&lang=ts"
import style0 from "./NewHighlightsSection.vue?vue&type=style&index=0&id=9fd8e94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd8e94c",
  null
  
)

export default component.exports